import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { IFields } from 'CMFW/grid/fields';
import { AgentQAModel } from 'models/AgentQAModel';
import AgentQADetails from '../components/AgentQADetails';
import AgentQACreate from '../components/AgentQACreate';
import { agentQAJobStatusRenderer } from 'CMFW/grid/cellRenderers/agentQAJobStatus';

const AgentQA: React.FC = () => {
  const forceRender = useForceRender();
  const [showCreate, setShowCreate] = useState(false);

  const model = useMemo(() => new AgentQAModel({ render: forceRender }), [forceRender]);

  const handleNewClick = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);

  const handleCreateSuccess = async (jobId: number) => {
    setShowCreate(false);
    await model.loadItemEdit(jobId);
  };

  const cellRenderers = useMemo(
    () => ({
      [IFields.status]: agentQAJobStatusRenderer,
    }),
    [],
  );

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={432}>
          <ContainerLeft>
            <Grid cellRenderers={cellRenderers} />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button variant="outlined" onClick={handleNewClick} size="small">
                new
              </Button>
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            {showCreate ? (
              <AgentQACreate model={model} onClose={handleCreateClose} onSuccess={handleCreateSuccess} />
            ) : model.itemId ? (
              <AgentQADetails />
            ) : (
              <EmptyState>
                <EmptyStateText>Select a QA job from the list or create a new one</EmptyStateText>
                <EmptyStateSubtext>
                  Agent QA tests AI agents with validated data to ensure prompt changes do not break existing
                  functionality
                </EmptyStateSubtext>
              </EmptyState>
            )}
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default AgentQA;

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
  padding: 40px;
`;

const EmptyStateText = styled.div`
  text-align: center;
  font-size: 16px;
  margin-bottom: 12px;
`;

const EmptyStateSubtext = styled.div`
  text-align: center;
  font-size: 14px;
  color: #999;
  max-width: 400px;
  line-height: 1.5;
`;
